import request from './request';

export const fetchSidebarData = async () => {

  let res = await request({
    url: 'api/v1/public/rba/listPrivilegesForRuntime',
    method: "GET"
  });

  if (res && res.response) {
    const data = res.response;
    return data;
  }
  return [];
}

export const fetchAllPostApprovelData = async (
  { accessType = null, planType = null, pagination = null, keyword = "", state_code = null, status = "PENDING_FOR_APPROVAL" }
) => {

  // Base payload
  const payload = {
    "_active": true,
    "category_id": 0,
    "keyword": keyword,
    "listing_id": "",
    "general": (!accessType),
    "planType": planType,
    "accessType": accessType,
    "state_code": state_code,
    "pagination": {
      "pageNumber": (pagination && pagination.pageNo) || 0,
      "pageSize": (pagination && pagination.pageSIze) || 20
    },
    "plan_id": "",
    "sort": {
      "columnName": "Created_On",
      "sortOrder": "desc"
    },
    "status": status,
    "user_id": ""
  };



  let res = await request({
    url: 'api/v1/private/listing/listListing',
    method: "POST",
    data: payload
  });

  if (res && res.response) {
    const data = res.response;
    return data;
  }
  return [];
}




export const fetchListPurchaseOrders = async (
  { id = null, accessType = null, planType = null, pagination = null, keyword = "", state_code = null, status = null }
) => {

  // Base payload
  const payload = {
    "_active": true,
    "pagination": {
      "pageNumber": (pagination && pagination.pageNo) || 0,
      "pageSize": (pagination && pagination.pageSIze) || 20
    },
    "sortBy": "LATEST",
    ...(!id && { statusFilter: [status] }),
    ...(id && { id })
  };



  let res = await request({
    url: 'api/v1/public/userAccessProfile/listPurchaseOrders',
    method: "POST",
    data: payload
  });

  if (res && res.response) {
    const data = res.response;
    return data;
  }
  return [];
}





export const fetchPostApprovelData = async ({ id }) => {

  let res = await request({
    url: `api/v1/private/listing/viewListing?listId=${id}`,
    method: "get"
  });

  if (res && res.response) {
    const data = res.response;
    return data;
  }
  return [];
}


export const updatePostApprovelData = async ({ id, status }) => {
  const finalId = typeof id === 'object' && id !== null ? id.listingId : id;


  let res = await request({
    url: `api/v1/private/listing/saveListing?listId=${finalId}&listingStatus=${status.type}&message=${status.message}`,
    method: "get"
  });

  if (res && res.success) {

    if (res.success === true) {

      return res;
    } else {
      alert("Something Went Wrong !")
    }

  }
  return [];
};

export const updatePostDays = async (ids, days, postingDetail = null) => {


  let res = [];

  if (postingDetail && postingDetail.intendedPlanType == 'OFFER') {
    let payload;

    // If multiple ids → create array of objects
    if (Array.isArray(ids)) {
      payload = ids;
    } else {
      payload = {
        listingId: ids,
        additionalPlanId: postingDetail?.additionalPlanId
      };
    }

    res = await request({
      url: `api/v1/private/listing/extendPlanByListingAndPlan?numberOfDays=${days}`,
      method: "put",
      data: payload
    });


  } else {

    const idArray = ids.map(item => item.listingId);
    res = await request({
      url: `api/v1/private/listing/extendPlanByListing?numberOfDays=${days}`,
      method: "put",
      data: idArray
    });
  }


  if (res && res.success) {
    return true;
  }
  return [];
};

export const fetchDealerPackageList = async (
  { accessType = null }
) => {

  let res = await request({
    url: `api/v1/private/plan/listByCategory?accessType=${accessType}`,
    method: "POST"
  });

  if (res && res.response) {
    const data = res.response;
    return data;
  }
  return [];
}


export const fetchPlanList = async () => {

  let res = await request({
    url: `api/v1/private/plan/list`,
    method: "POST",
    data: {
      "planType": "ADVERTISEMENT"
    }
  });

  if (res && res.response) {
    const data = res.response;
    return data;
  }
  return [];
}



export const fetchNotificationPlanList = async () => {

  let res = await request({
    url: `api/v1/private/plan/list`,
    method: "POST",
    data: {
      "planType": "PUSH_NOTIFICATION"
    }
  });

  if (res && res.response) {
    const data = res.response;
    return data;
  }
  return [];
}


export const fetchCountForAllCategories = async () => {

  let res = await request({
    url: `api/v1/private/listing/getCountForAllCategories`,
    method: "POST",
    data: {
      "status": [
        "PENDING_FOR_APPROVAL",
        "APPROVED",
        "REJECTED_TO_RESUBMIT",
        "VERIFIED",
        "INACTIVE"
      ]
    }
  });

  if (res && res.response) {
    const data = res.response;
    return data;
  }
  return [];
}

export const savePlan = async (data = {}) => {

  let res = await request({
    url: `api/v1/private/plan/save`,
    method: "POST",
    data
  });

  if (res && res.success) {
    const data = res.success;
    return data;
  }
  return null;
}

export const updateAdvertisementPackage = async (data = {}) => {

  let res = await request({
    url: `api/v1/private/plan/updateAdvertisementPackage`,
    method: "POST",
    data
  });

  if (res && res.success) {
    const data = res.success;
    return data;
  }
  return null;
}


export const fetchFreePackageList = async () => {

  let res = await request({
    url: `api/v1/private/plan/listFreePackages`,
    method: "POST"
  });

  if (res && res.response) {
    const data = res.response;
    return data;
  }
  return [];
}

export const getAccessibleLanguagePacks = async ({ brandAndBread }, pageNumber, searchKeyword, showEmptyOnly, selectedLangArray) => {

  let data = {
    // "englishValue": "string",
    "filterGroup": "All",
    "filterString": '*' + searchKeyword + '*',
    "pageNumber": pageNumber,
    "pageSize": 20,
    "selectedLanguages": selectedLangArray,
    "showEmptyOnly": showEmptyOnly
  }

  let res = await request({

    url: `api/v1/private/language/getAccessibleLanguagePacks1`,
    method: "POST",
    data
  });

  if (res && res.response) {
    const data = res.response;
    return data;
  }
  return [];
}

export const getRegistrationsList = async (keyword, accessId, selectedStateId, selectedFilterStatus, filter) => {


  let filterConditions = [];
  if (keyword) {
    filterConditions.push(
      {
        "column": "Name",
        "value": keyword
      }
    )
  }

  if (accessId) {
    filterConditions.push(
      {
        "column": "AccessId",
        "value": accessId
      }
    )
  }
  if (selectedFilterStatus) {
    filterConditions.push(
      {
        "column": "Status",
        "value": selectedFilterStatus
      }
    )
  } else {
    filterConditions.push(
      {
        "column": "Status",
        "value": 'PENDING_APPROVAL'
      }
    )
  }

  if (selectedStateId) {
    filterConditions.push(
      { column: "State", value: selectedStateId }
    )
  }
  let res = await request({
    url: `api/v1/private/registration/list`,
    method: "POST",
    data: {
      filterConditions,
      "pageNumber": filter.pageNumber ?? 1,
      "pageSize": 20,
      "sortCondition": {
        // "field": "LastUpdateOn",
        "field": (selectedFilterStatus !== 'APPROVED' ? "LastUpdateOn" : "ApprovedOn"),
        "order": (selectedFilterStatus !== 'APPROVED' ? "asc" : "desc")
      }
    }
  });

  if (res && res.response) {
    const data = res.response;
    return data;
  }
  return [];
}

export const updateLanguagePack = async ({
  displayCode,
  language,
  value
}) => {

  let res = await request({
    url: `api/v1/private/language/language-pack-update?forceUpdate=true&language=${language}`,
    method: "POST",
    data: {
      "displayCode": displayCode,
      "value": value
    }
  });

  if (res && res.response) {
    const data = res.response;
    return data;
  }
  return [];
}


export const getlistDataAccessForUser = async (userId) => {

  let res = await request({
    url: `api/v1/private/dataAccess/listDataAccessForUser?type=LISTING_STATE&userId=${userId}`,
    method: "GET"
  });

  if (res && res.response) {
    const data = res.response;
    return data;
  }
  return [];
}


export const getStatistics = async (userId) => {

  let res = await request({
    url: `api/v1/private/registration/getStatistics`,
    method: "POST"
  });

  if (res && res.response) {
    const data = res.response;
    return data;
  }
  return [];
}



export const updatePurchaseOrderStatus = async ({ id, status }) => {

  let res = await request({
    data: {
      "id": id,
      "status": status
    },
    url: `api/v1/public/userAccessProfile/updatePurchaseOrderStatus`,
    method: "post"
  });

  if (res && res.success) {

    if (res.success === true) {

      return res;
    } else {
      alert("Something Went Wrong !")
    }

  }
  return [];
};
